import BaseAPI from '@/apis/base'
import { apis, getApiUrl } from '../api-config'

class DefaultActionAPI extends BaseAPI {}

export default new DefaultActionAPI('v1/default-actions', 'DefaultAction', getApiUrl(apis.CommonAPI))
